import type { DmTokenResponse, DmTokenResponseSuccess } from '@nsftx/systems-sdk'
import deviceManagementService from './deviceManagementService'
import DMTokenError from '#src/classes/DmTokenError'

const isTokenResponseSuccess = (response: DmTokenResponse): response is DmTokenResponseSuccess =>
  response.success

/**
 * @throws {DMTokenError}
 */
const getAccessToken = async () => {
  const core = deviceManagementService.getCore()
  const response = await core.getNxGTerminalToken()

  if (!isTokenResponseSuccess(response)) {
    throw new DMTokenError(response.error, 'DM_TOKEN_GET_ACCESS_TOKEN_ERROR')
  }

  return response.token
}

export default {
  getAccessToken
}
